/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function SyncIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.05572 2.50033C9.27122 2.50033 10.4226 2.89755 11.3741 3.62049L9.17161 5.69399L14.7737 6.29471L14.5103 0.666992L12.2767 2.77044C11.085 1.80488 9.611 1.2781 8.05572 1.2781C4.34933 1.2781 1.3335 4.29394 1.3335 8.00033H2.55572C2.55572 4.96738 5.02277 2.50033 8.05572 2.50033Z"
        fill="#5C5F62"
      />
      <path
        d="M8.05535 13.5C6.83985 13.5 5.68851 13.1028 4.73701 12.3798L6.93946 10.3063L1.3374 9.70561L1.60079 15.3333L3.8344 13.2299C5.02607 14.1954 6.50007 14.7222 8.05535 14.7222C11.7617 14.7222 14.7776 11.7064 14.7776 8H13.5553C13.5553 11.0329 11.0883 13.5 8.05535 13.5Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
